<script>
import bem from '@/utils/bem';

const b = bem('placeholder-image-selector');
export default {
  props: {
    images: Array,
    imageId: {
      type: Number,
      required: true,
    },
    show: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    handleOk() {
      this.hideModal();
    },
    change(imageId) {
      this.$emit('update:imageId', imageId);
    },
    hideModal() {
      this.$emit('update:show', false);
    },
  },
};
</script>

<template>
  <a-modal :open="show" :footer="null" width="650px" @cancel="hideModal">
    <div :class="b('')">
      <button
        v-for="image in images"
        :key="image.id"
        :class="b('image-wrap', { selected: imageId === image.id })"
        type="button"
        @click="change(image.id)"
      >
        <img :class="b('image')" :src="image.imageUrl" :alt="image.id" />
      </button>
    </div>
  </a-modal>
</template>

<style lang="scss">
@import "@/styles/variables";

.placeholder-image-selector {
  max-width: 880px;
  max-height: 660px;
  overflow-y: auto;
  display: flex;
  flex-wrap: wrap;
  gap: 20px 20px;
  margin-top: 20px;
  margin-bottom: 20px;

  &__image-wrap {
    width: 200px;
    height: 200px;
    border: 1px solid $gull-gray-color;

    &_selected {
      border: 2px solid $tacao;
    }
  }

  &__image {
    width: 196px;
    height: 196px;
    object-fit: contain;
    object-position: center;
  }
}
</style>
